module.exports = "https://www.gc-qa.gnp.com.mx/e6328902e099ed89d1002b3fb73e00e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/vida/4.png
// module id = 382
// module chunks = 0 1